/* eslint no-debugger: "warn" */

// dependencies
import React from 'react';

import LocalStorageService from './LocalStorageService';
import ApiService from './ApiService';

import { v4 as uuidv4 } from 'uuid';

// import axios from 'axios';

const currentOrg = LocalStorageService.get('activeOrg');
const currentSite = LocalStorageService.get('activeSite');


class SSOService extends React.Component {

  getLoginURL = () => {
    return `${ApiService._getServerRoot()}/api/sso/cognito-start`;
  }

  getConnectLoginURL = () => {
    return `${ApiService._getServerRoot()}/sso/auth/login`;
  }

  startSignup = async (email) => {
    // POST /api/sso/signup-start
    const serverRoot = ApiService._getServerRoot();
    const request = new Request(`${serverRoot}/api/sso/signup-start`, {
      method: 'POST',
      cache: 'no-store',
      body: JSON.stringify({ email })
    });
    const response = await fetch(request);
    let data = await response.json();

    if (data.status !== "SSO_SIGNUP_STARTED") {
      throw new Error(data.message || 'Failed to start SSO signup');
    }
    return data.token;
  }
  completeSignup = async (data) => {

    const { sessionToken, firstName, lastName, schoolURN = '', schoolCustomName = '', verificationCode } = data;

    if (!sessionToken) {
      throw new Error('No SSO session token available');
    }

    if (!firstName || !lastName) {
      throw new Error('First name and last name are required');
    }

    if (!schoolURN && !schoolCustomName) {
      throw new Error('Either school URN or school custom name is required');
    }

    if (!verificationCode) {
      throw new Error('Verification code is required');
    }

    const options = {
      method: 'POST',
      cache: 'no-store',
      body: JSON.stringify({
        firstName,
        lastName,
        schoolURN,
        schoolCustomName: !schoolURN ? schoolCustomName : undefined,
        verificationCode: verificationCode?.trim()
      })
    };

    options.headers = new Headers();
    options.headers.append('x-sso-session-token', sessionToken);
    options.headers.append('Cache-Control', 'no-cache');

    let rid = uuidv4();

    const serverRoot = ApiService._getServerRoot();
    const request = new Request(`${serverRoot}/api/sso/signup-complete?r=${rid}`, options);
    const response = await fetch(request);
    return response.json();
  }

  getProfile = async (sessionToken) => {

    if (process.env.FEATURE_SSO_ENABLED !== "true") {
      throw new Error('SSO is currently disabled');
    }

    if (!sessionToken) {
      throw new Error('No SSO session token available');
    }


    const options = {
        method: 'GET',
        cache: 'no-store',

    };

    options.headers = new Headers();
    options.headers.append('x-sso-session-token', sessionToken);
    options.headers.append('Cache-Control', 'no-cache');

    let rid = uuidv4();

    const serverRoot = ApiService._getServerRoot();
    const request = new Request(`${serverRoot}/api/sso/profile?r=${rid}`, options);
    const response = await fetch(request);
    return response.json();
  }

  updateProfile = async (sessionToken, firstName, lastName, schoolURN, schoolCustomName = '') => {

    if (!sessionToken) {
      throw new Error('No SSO session token available');
    }

    if (!firstName) {
      throw new Error("firstName is required")
    }

    if (schoolURN && schoolCustomName) {
      throw new Error("schoolURN or schoolCustomName is required")
    }

    const options = {
        method: 'PATCH',
        cache: 'no-store',
        body: JSON.stringify({
          firstName,
          lastName,
          schoolURN,
          schoolCustomName: schoolCustomName
        })
    };

    options.headers = new Headers();
    options.headers.append('x-sso-session-token', sessionToken);
    options.headers.append('Cache-Control', 'no-cache');

    let rid = uuidv4();

    const serverRoot = ApiService._getServerRoot();
    const request = new Request(`${serverRoot}/api/sso/profile?r=${rid}`, options);
    const response = await fetch(request);
    return response.json();
  }

  searchSchools = async (searchTerm) => {
    const sessionToken = this.getSSOSessionToken();

    if (!sessionToken) {
      throw new Error('No SSO session token available');
    }

    const options = {
      method: 'GET',
      cache: 'no-store',
      headers: new Headers()
    };

    options.headers.append('x-sso-session-token', sessionToken);
    options.headers.append('Cache-Control', 'no-cache');

    const serverRoot = ApiService._getServerRoot();
    const request = new Request(
      `${serverRoot}/api/sso/school-search?s=${encodeURIComponent(searchTerm)}`,
      options
    );
    const response = await fetch(request);
    const data = await response.json();

    if (!response.ok || data.status === 'error') {
      throw new Error(data.message || 'Unable to search for schools');
    }

    return data.results || [];
  }

  getDevCallbackURL = () => {
    return `${ApiService._getServerRoot()}/api/auth/complete-sso`;
  }

  getSSOSessionToken = () => {
    return LocalStorageService.get('ssoSessionToken');
  }

  getOrCreateSSOSessionToken = async (email) => {
    let sessionToken = LocalStorageService.get('ssoSessionToken');
    if (!sessionToken) {
      sessionToken = await this.startSignup(email);
      LocalStorageService.set('ssoSessionToken', sessionToken)
    }
    return sessionToken;
  }

  clearSSOSessionToken = () => {
    LocalStorageService.remove('ssoSessionToken');
  }

  setSSOSessionToken = (token) => {
    LocalStorageService.set('ssoSessionToken', token);
  }

}

// export default Api
export default new SSOService();
